import { render, staticRenderFns } from "./RegisterPRT2005.vue?vue&type=template&id=9bc50570&"
import script from "./RegisterPRT2005.vue?vue&type=script&lang=js&"
export * from "./RegisterPRT2005.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports